<template>
    <div>
        <el-form :model="form" :rules="rules" ref="form" label-width="200px">
            <el-form-item label="名称" prop="name">
                <el-input v-model="form.name" placeholder="输入名称" :clearable="true"></el-input>
            </el-form-item >
<!--            <el-form-item label="分组" prop="categoryId">-->
<!--                <el-select v-model="form.categoryId" filterable placeholder="请选择">-->
<!--                    <el-option-->
<!--                        reserve-keyword-->
<!--                        v-for="item in categoryList"-->
<!--                        :key="item.key"-->
<!--                        :label="item.value"-->
<!--                        :value="item.key">-->
<!--                    </el-option>-->
<!--                </el-select>-->
<!--            </el-form-item>-->
            <el-form-item label="标签">
                <el-select v-model="form.tagIds"
                           clearable
                           filterable
                           multiple placeholder="请选择">
                    <el-option
                        v-for="item in tagList"
                        :key="item.key"
                        :label="item.value"
                        :value="item.key">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="类型">
                <el-radio-group v-model="form.type">
                    <el-radio :label="0">文字</el-radio>
                    <el-radio :label="1">音频</el-radio>
                    <el-radio :label="2">图片</el-radio>
                    <el-radio :label="3">视频</el-radio>
                    <el-radio :label="6">文件</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="内容" prop="content">
                <el-input v-if="form.type === 0"
                          v-model="form.content"
                          :autosize="{ minRows: 2, maxRows: 10}"
                          type="textarea"
                          placeholder="输入内容"
                />
                <uploadVideo v-if="form.type === 3" v-model="form.content"
                             :text="['视频大小500m以内', '视频格式mp4']"></uploadVideo>
                <upload-audio v-if="form.type === 1" v-model="form.content"
                              :text="['音频文件100M以内', '视频格式mp3']"></upload-audio>

                <upload-image-bat v-if="form.type === 2" :show-sel-file="false" v-model="form.content" :max="1"
                            :text="['图片大小5M以内', '图片格式png/jpg/gif']"></upload-image-bat>
              <upload-file  v-if="form.type === 6" v-model="form.content" :text="['文件大小1000M以内']"></upload-file>
            </el-form-item>
        </el-form>
        <div class="footer">
            <el-button @click="$emit('close-dialog')">取 消</el-button>
            <el-button type="success" @click="confirm('form')">确定</el-button>
        </div>
    </div>
</template>
<script>

import { addFileResource, fileCategoryOptions, fileTagOption } from '@/api/demo/file'
import uploadAudio from '@/components/uploadAudio/index.vue'
import uploadVideo from '@/components/uploadVideo/index.vue'
import uploadImageBat from '@/components/uploadImageBat/index.vue'
import uploadFile from '@/components/uploadFile/index.vue'

export default {
  name: 'fileResourceEdit',
  components: {
    uploadFile,
    uploadVideo,
    uploadAudio,
    uploadImageBat
  },
  props: {
    categoryId: {
      type: String,
      default: () => {
        return '0'
      }
    }
  },
  data () {
    return {
      id: '', // id

      tagList: [],
      categoryList: [],
      form: {
        type: 0, // 图标
        name: '', // 活动名称
        content: '',
        tagIds: []
      },
      replyOptionLoading: false,
      rules: {
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 50,
            message: '长度在 1 到 50 个字符',
            trigger: 'blur'
          }
        ],
        categoryId: [
          {
            required: true,
            message: '请选择分组',
            trigger: 'blur'
          }
        ],
        content: [
          {
            required: true,
            message: '内容为空',
            trigger: 'blur'
          }
        ]

      }
    }
  },
  created () {
    let that = this
    that.form.categoryId = that.categoryId
    that.id = that.$route.query.id
    if (that.id != null) {
      that.getInfo(that.id)
    }
    fileTagOption().then(res => {
      this.tagList = res
    })
    fileCategoryOptions().then(res => {
      this.categoryList = res
    })
  },
  methods: {
    getInfo (id) {

    },
    confirm () {
      this.getCreate('form')
    },
    getCreate (forms) {
      let that = this
      that.$refs[forms].validate(valid => {
        addFileResource(that.form).then(res => {
          that.form = {
            type: 0, // 图标
            name: '', // 活动名称
            content: ''
          }
          that.$emit('close-dialog')
          that.$notify({
            title: '成功',
            message: '新增成功',
            type: 'success',
            duration: 2000
          })
          // that.$router.push("/demo/helper/keyword");
        })
      })
      // 编辑
    }
  },

  mounted () {
  }
}
</script>
<style scoped>
/deep/ .el-input-number {
    margin-right: 12px;
}

.footer {
    text-align: center;
    margin-top: 20px;
}
</style>
